import { useCompleteFragment } from '@eluve/apollo-client';
import {
  appointmentTotalDurationFragment,
  getAppointmentTotalDuration,
} from '@eluve/shared-gql-operations';

export { appointmentTotalDurationFragment, getAppointmentTotalDuration };

export const useAppointmentTotalDuration = (appointmentId: string) => {
  const data = useCompleteFragment({
    fragment: appointmentTotalDurationFragment,
    strict: false,
    key: {
      id: appointmentId,
    },
  });

  return data?.totalDuration ?? 0;
};
